import { postRequest} from "../libs/AxiosService.util";

export async function serviceGetDashboard(params) {
    return await postRequest('dashboard/counts', params);
}
export async function serviceGetTopUsers(params) {
    return await postRequest('dashboard/top/users', params);
}
export async function serviceGetTopPrograms(params) {
    return await postRequest('dashboard/top/programs', params);
}
